import { Button, Link } from '@servicetitan/anvil2';
import { Centered } from '../common/components/centered';
import { useDependencies } from '@servicetitan/react-ioc';
import { AppStore } from '../stores/app.store';
import { Redirect } from 'react-router-dom';

export function LoginPage() {
    const [{ authorized }] = useDependencies(AppStore);

    if (authorized) {
        return <Redirect to={{ pathname: '/' }} />;
    }

    const loginHref = `/bff/login?returnUrl=${encodeURIComponent('/')}`;

    return (
        <Centered className="m-block-start-8">
            <Link href={loginHref} appearance="primary" ghost>
                <Button>Login</Button>
            </Link>
        </Centered>
    );
}
